import React from 'react'
import KanBoIcon from 'components/KanBoIcon'
import { ListItem } from 'components/List'
import getCharCount from 'components/RichText/utils/getCharCount'
import RichTextContent from 'components/RichText/Content'
import Info from 'components/Info'
import styled from 'styled-components'

const TypedRichTextContent: any = RichTextContent

const StyledInfo = styled(Info)`
  margin-left: 0.5em;
`

type Props = React.ComponentProps<typeof ListItem> & {
  name: string;
  description?: any;
}

const BlockerListItem: React.FC<Props> = ({
  name,
  description,
  ...props
}) => {
  return (
    <ListItem
      {...props}
      icon={
        <KanBoIcon fixedWidth name='kanbo-16-block' />
      }
    >
      {name}
      {(description && getCharCount(description) > 0) &&
        <StyledInfo>
          <TypedRichTextContent
            content={description}
          />
        </StyledInfo>
      }
    </ListItem>
  )
}

export default BlockerListItem
